import React, { forwardRef, ReactNode } from 'react';
import cn from 'classnames';

type BoxProps = {
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

const Box = forwardRef<HTMLDivElement, BoxProps>(({ children, className, style }, ref) => {
  return (
    <div
      ref={ref}
      style={style}
      className={cn('bg-white', 'shadow-medium', 'rounded-[10px]', className)}
    >
      {children}
    </div>
  );
});

Box.displayName = 'Box';

export default Box;
